import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';
import enquire from 'enquire.js';
import Isotope from 'isotope-layout';
import $ from 'jquery';
class Bricks {
    constructor(el) {
        this.el = el;
        this.groupsEl = el.find('.bricks__groups');
        this.groupsEl.children().each(function() {
            if($(this).hasClass('bricks__group--slider')) {
                new Slider($(this).find('.bricks__group__slider'), {
                    dots: true,
                    arrows: false,
                    fade: true,
                });
            }
        });
        this.isotope = null;
        enquire.register('screen and (min-width: ' + breakpoints.desktop + 'px)', {
            match: () => {
                this.isotope = new Isotope(this.groupsEl[0], {
                    itemSelector: '.bricks__intro, .bricks__group',
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.bricks__sizer',
                        gutter: 0
                    }
                });
            },
            unmatch: () => {
                if(this.isotope) {
                    this.isotope.destroy();
                    this.isotope = null;
                }
            }
        });
    }
}

export default Bricks;